import React, { useEffect, useState } from 'react';
import badgerSetupImg from './badger_setup.png';
import './setup-styles.css';

interface SetupOverlayProps {
	onComplete?: () => void;
}

const DURATION = 3500;

const BadgerSetupOverlay: React.FC<SetupOverlayProps> = ({ onComplete }) => {
	const [phase, setPhase] = useState<'enter' | 'hold' | 'exit'>('enter');

	useEffect(() => {
		const t1 = setTimeout(() => setPhase('hold'), 800);
		const t2 = setTimeout(() => setPhase('exit'), DURATION - 600);
		const t3 = setTimeout(() => onComplete?.(), DURATION);
		return () => {
			clearTimeout(t1);
			clearTimeout(t2);
			clearTimeout(t3);
		};
	}, [onComplete]);

	return (
		<div
			className={`setup-overlay ${phase}`}
			style={{ pointerEvents: 'none' }}
		>
			<div className="setup-scene">
				{Array.from({ length: 10 }).map((_, i) => (
					<div key={i} className={`setup-confetti setup-confetti-${i % 5}`} />
				))}

				<div className="setup-image-wrap">
					<img
						src={badgerSetupImg}
						alt="Badger setting up a HAAS CNC mill"
						className="setup-image"
						draggable={false}
					/>
				</div>

				<div className="setup-text">Setup Time!</div>

				<div className="setup-sparkle setup-sparkle-1">⚙</div>
				<div className="setup-sparkle setup-sparkle-2">🔧</div>
				<div className="setup-sparkle setup-sparkle-3">✦</div>
				<div className="setup-sparkle setup-sparkle-4">✦</div>
			</div>
		</div>
	);
};

export default BadgerSetupOverlay;
